import { SET_FAQ_EXPANDED_NODE_IDS, SET_FAQ_GROUP, SET_FAQ_GROUP_MAP, SET_FAQ_SCROLL_TO_ID } from './types'
import { FAQGroup } from '../../interfaces/faq'
import { AppDispatch } from 'redux/store'

const updateGroupMap = ({ parentId: _parentId, group: _group, groupMap }: { parentId: string | null, group: FAQGroup[], groupMap: Map<string, string> }): void => {
  for (let i = 0; i < _group.length; i++) {
    const { id, group } = _group[i]
    if (_parentId !== null) groupMap.set(id, _parentId)
    updateGroupMap({ parentId: id, group, groupMap })
  }
}

const setFaqGroupMap = (groupMap: Map<string, string>): { type: typeof SET_FAQ_GROUP_MAP, groupMap: Map<string, string> } => ({
  type: SET_FAQ_GROUP_MAP,
  groupMap
})

export const setFaqGroup = (group: FAQGroup[]): (dispatch: AppDispatch) => void => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: SET_FAQ_GROUP,
      group
    })

    const groupMap = new Map<string, string>()
    updateGroupMap({ parentId: null, group, groupMap })
    dispatch(setFaqGroupMap(groupMap))
  }
}
export const setFaqExpandedNodeIds = (nodeIds: string[]): { type: typeof SET_FAQ_EXPANDED_NODE_IDS, nodeIds: string[] } => ({
  type: SET_FAQ_EXPANDED_NODE_IDS,
  nodeIds
})

export const setFaqScrollToId = (scrollToId: string | null): { type: typeof SET_FAQ_SCROLL_TO_ID, scrollToId: string | null } => ({
  type: SET_FAQ_SCROLL_TO_ID,
  scrollToId
})
